"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Indicator_1 = __importDefault(require("./Indicator"));
class IndicatorManater {
    constructor(stage, signals) {
        this.stage = stage;
        this.signals = signals;
        this.indicators = [];
        this.isFirstIndicator = true;
        this.$dom = document.getElementById('indicators');
        this.clickHandler = this._clickedIndicator.bind(this);
        this._init();
    }
    update() {
        this.indicators.forEach(indicator => {
            indicator.update(this.stage.size.width / 2, this.stage.size.height / 2, this.stage.camera);
        });
    }
    _clickedIndicator() {
        this._remove().then(() => this._next());
    }
    _next() {
        this.signals.nextChapter.dispatch();
    }
    _add(target, offset, color) {
        var _a;
        const indicator = new Indicator_1.default(this.isFirstIndicator);
        indicator.setPosition(target, offset);
        indicator.setColor(color);
        indicator.addEventListener('click-indicator', this.clickHandler);
        this.indicators.push(indicator);
        (_a = this.$dom) === null || _a === void 0 ? void 0 : _a.appendChild(indicator.getDom());
    }
    _remove(timer = 0.5) {
        return new Promise(resolve => {
            const indicator = this.indicators[0];
            if (!indicator)
                return;
            this.indicators.splice(0, 1);
            indicator.fadeOut(timer, () => {
                var _a;
                (_a = this.$dom) === null || _a === void 0 ? void 0 : _a.removeChild(indicator.getDom());
                resolve();
            });
        });
    }
    _hideIndicatorText() {
    }
    _init() {
        this.signals.readyNextChapter.add(this._add.bind(this));
        this.signals.hideIndicatorText.add(this._hideIndicatorText.bind(this));
    }
}
exports.default = IndicatorManater;
